
    // Load featured GitHub projects for homepage
    async function loadFeaturedProjects() {
      try {
        const response = await fetch('https://api.github.com/users/MuhdAminRahman/repos?sort=updated&per_page=3');
        const repos = await response.json();
        
        const featuredGrid = document.getElementById('featured-projects-grid');
        
        if (repos.length > 0) {
          // Clear existing placeholder projects
          featuredGrid.innerHTML = '';
          
          // Create featured project cards
          repos.forEach(repo => {
            if (!repo.fork) { // Only show non-forked repos
              const projectCard = createFeaturedProjectCard(repo);
              featuredGrid.appendChild(projectCard);
            }
          });
        }
      } catch (error) {
        console.log('Using fallback featured projects:', error);
        // Keep the fallback projects if API fails
      }
    }
    
    function createFeaturedProjectCard(repo) {
      const card = document.createElement('article');
      card.className = 'project-card card';
      card.tabIndex = '0';
      card.role = 'article';
      
      const lang = repo.language || 'Multiple';
      const desc = repo.description || 'Software development project showcasing programming skills.';
      const shortDesc = desc.length > 100 ? desc.substring(0, 100) + '...' : desc;
      
      card.innerHTML = `
        <div class="project-header">
          <h3>${repo.name.replace(/-/g, ' ').replace(/_/g, ' ')}</h3>
          <span class="project-category">${getProjectType(repo)}</span>
        </div>
        <p class="project-desc">${shortDesc}</p>
        <div class="project-meta">
          <div class="meta-item">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
              <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
            </svg>
            <span>${repo.size} KB</span>
          </div>
        </div>
        <div class="project-tech">
          <span class="tech-tag">${lang}</span>
        </div>
        <div class="project-links">
          <a href="${repo.html_url}" class="btn-link" target="_blank" rel="noopener">
            View on GitHub
          </a>
        </div>
      `;
      
      return card;
    }
    
    function getProjectType(repo) {
      const name = repo.name.toLowerCase();
      const desc = (repo.description || '').toLowerCase();
      
      if (name.includes('web') || desc.includes('web') || desc.includes('react') || desc.includes('vue')) {
        return 'Web Dev';
      } else if (name.includes('mobile') || desc.includes('mobile') || desc.includes('android') || desc.includes('ios')) {
        return 'Mobile';
      } else if (name.includes('data') || desc.includes('data') || desc.includes('structure') || desc.includes('algorithm')) {
        return 'Data Structures';
      } else if (name.includes('database') || desc.includes('database') || desc.includes('sql') || desc.includes('mongo')) {
        return 'Database';
      } else {
        return 'Software';
      }
    }
    
    // Load featured projects when page loads
    document.addEventListener('DOMContentLoaded', loadFeaturedProjects);
  